import { Component, OnInit } from '@angular/core';
import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-use-rfid',
  templateUrl: './use-rfid.component.html',
  styleUrls: ['./use-rfid.component.scss']
})
export class UseRfidComponent implements OnInit {

  rootScopeData: RootScopeDeclare;
  userId: Number;
  cloudBasePath: string;
  serviceBasePath: string;

  constructor(private rootScopeService: RootScopeService, private router: Router) { }
  
   getRootScopeData(): void {
     this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
   }
 
   setPageName(): void {
     this.rootScopeData.pageName = 'use-rfid';
   }
 
   ngOnInit() {
     this.getRootScopeData();
     this.setPageName();
     this.cloudBasePath = environment.cloudBasePath;
     this.serviceBasePath = environment.servicePath;
     this.userId=this.rootScopeData.currentUser.userId;

   }
   onBack(): void {
     this.router.navigate(['/facility/rfid/addMembers']);
   }

}
